import * as React from "react";
import { OnDisplay, OnDisplayProps } from "../OnDisplay/OnDisplay";
import classNames from "classnames";
import RelatedItemsInfo from "../RelatedItemsInfo/RelatedItemsInfo";

type CollectionItemKeyInfoProps = {
    title: string;
    displayDate: string;
    medium: string;
    description: string;
    catalogueRaisonne: string;
    inventoryNumberTitle: string;
    inventoryNumber: string;
    onDisplay: OnDisplayProps;
    isVirtualObject: boolean;
    numberOfChildren: number;
    virtualObject: {
        virtualCollectionDescriptionString: string;
        virtualCollectionLinkString: string;
        virtualParentInvNo: string;
        virtualParentRelationships: number;
        virtualObjectInfoString: string;
    };
    showMoreDetailsLinkText: string;
    aboutObjectText: string;
    classification: string;
};

export const CollectionItemKeyInfo = React.forwardRef<HTMLDivElement, CollectionItemKeyInfoProps>((props, ref) => {
    const getCatalogueRaisonneText = (text: string) => {
        return text
            .replace("Schiefler", "<br>Schiefler")
            .replace("Willoch", "<br>Willoch")
            .replace("Presler", "<br>Presler")
            .split("<br>");
    };

    const scrollToMetadataSection = () => {
        if (ref && typeof ref !== "function" && ref.current) {
            ref.current.scrollIntoView({ behavior: "smooth" });
            setTimeout(() => {
                ref.current?.focus();
            }, 1000);
        }
    };

    return (
        <div
            className={classNames("CollectionItemKeyInfo", {
                "CollectionItemKeyInfo--is-virtual-object": props.isVirtualObject,
            })}
        >
            <h1
                className={classNames("CollectionItemKeyInfo__title", {
                    "CollectionItemKeyInfo__title--is-virtual-object": props.isVirtualObject,
                })}
            >
                {props.title}
            </h1>
            <div>
                <p>{props.medium}</p>
                <p>{props.displayDate}</p>
            </div>
            {props.onDisplay && props.onDisplay.link && props.onDisplay.linkText && <OnDisplay {...props.onDisplay} />}
            {props.classification !== "Malerier" && props.description && !props.isVirtualObject && (
                <div>
                    <h2 className="CollectionItemKeyInfo__subtitle">{props.aboutObjectText}</h2>
                    <p>{props.description}</p>
                </div>
            )}
            {props.virtualObject &&
                props.virtualObject.virtualParentInvNo &&
                props.virtualObject.virtualCollectionDescriptionString &&
                props.virtualObject.virtualParentRelationships > 1 && (
                    <RelatedItemsInfo
                        virtualCollectionDescriptionString={props.virtualObject.virtualCollectionDescriptionString}
                        virtualParentRelationships={props.virtualObject.virtualParentRelationships}
                        virtualParentMedium={props.medium}
                        virtualCollectionLinkString={props.virtualObject.virtualCollectionLinkString}
                        virtualParentInvNo={props.virtualObject.virtualParentInvNo}
                    />
                )}
            {props.inventoryNumber && (
                <div>
                    <h2 className="CollectionItemKeyInfo__subtitle">{props.inventoryNumberTitle}</h2>
                    <p>{props.inventoryNumber}</p>
                </div>
            )}
            {props.catalogueRaisonne && (
                <div>
                    <h2 className="CollectionItemKeyInfo__subtitle">Catalogue raisonné</h2>
                    <ul className="CollectionItemKeyInfo__catalogue-raisonne-list">
                        {getCatalogueRaisonneText(props.catalogueRaisonne).map((e, i) => (
                            <li key={i}>{e}</li>
                        ))}
                    </ul>
                </div>
            )}
            <button className="CollectionItemKeyInfo__show-more-details-button" onClick={scrollToMetadataSection}>
                {props.showMoreDetailsLinkText}
            </button>
            {props.isVirtualObject && props.numberOfChildren > 1 && (
                <RelatedItemsInfo
                    isVirtualObject={props.isVirtualObject}
                    virtualParentRelationships={props.numberOfChildren}
                    virtualParentMedium={props.medium}
                    virtualCollectionDescriptionString={props.virtualObject.virtualObjectInfoString}
                />
            )}
        </div>
    );
});
